<script>
    export let placeholder='placeholder', area, index, field_store_name, padding_top='1.5em', align='start', text='left', updateCallback, value, readonly=false;
</script>

<label for={placeholder} class="field" style="--area: {area}; --text-align: {text}; --align-self: {align}; --padding_top:{padding_top};">
    <textarea value={value} name={placeholder} required readonly={readonly} on:blur={(val) => {if(readonly==false){updateCallback(index, field_store_name, val.target.value)}}} style="cursor:{readonly ? 'default' : ''}" />
    {#if readonly==false}
        <span class="placeholder">{placeholder}</span>
    {/if}
    <div class="line"></div>
</label>

<style lang="scss">
    @use "styles/global.scss";

    $height: 1.2em;
    $side-padding: 0.5em;

    .field{
        grid-area: var(--area);

        position: relative;
        pointer-events: none;
        font: inherit;

        padding: 0px $side-padding;
        //padding-top: 88px;
        padding-top: var(--padding_top);

        textarea{
            @include input_textarea;
            width: 100%;
            height: 100%;
            overflow-y: scroll;
            @include custom_scrollbar;

            justify-self: stretch;
            text-align: var(--text-align);
            text-transform:none;
            /*
            &::first-letter{
                text-transform:capitalize;
            }
            */

            pointer-events:all;
            
            font-size: 18px;

            &:valid + .placeholder,
            &:focus + .placeholder{
                transform: translateY(-1.5 * $height);
                font-size: 14px;
            }
            
        }
        
        .placeholder{
            position: absolute;
            left: 0 + $side-padding;
            top: var(--margin_top);

            width: auto;
            justify-self: stretch;
            text-align: var(--text-align);

            color: $grey5;
            font-size: 18px;

            transition: 0.3s ease;
        }

        .line{
            @include line($color:$grey5);
        }
    }
</style>